/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$("input.search__form-input").focus(function(){
 	$('form.search__form').addClass('focus');
});

$("input.search__form-input").focusout(function(){
 	$('form.search__form').removeClass('focus');
});

